import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "text",
        options: {
          data: "Crowd",
          scrollbars: false,
        },
      },
      styles: {
        justifyContent: "flex-start",
        fontSize: "12px",
        fontWeight: 700,
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "original",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/original-crowd.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "62",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/62-massive-crowd.wav`,
          styles: {
            margin: 0,
          },
          style: {
            margin: 0,
          },
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "58",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/58-massive-crowd.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "54",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/54-massive-crowd.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "50",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/50-massive-crowd.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "46",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/46-massive-crowd.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "42",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/42-massive-crowd.wav`,
        },
      },
    },
  },
];

export default components;
